// extracted by mini-css-extract-plugin
module.exports = {"description":"UpdateTextArea_description__3OSUd","descriptionLabel":"UpdateTextArea_descriptionLabel__SitLj","descriptionInput":"UpdateTextArea_descriptionInput__32-GR"};